export default {
    URL: 'https://www.threetop.cn',
    jm: 'ab699483c557'
}